import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';

function CancelButton({ cancelHandler}) {
  const navigate = useNavigate();
  return (
    <>
      <Button style={{backgroundColor:'#f9ae3b'}} onClick={cancelHandler}  className='cancel-btn rounded-1'>CANCEL</Button>
    </>
  );
}

export default CancelButton;